import type { AlertChannelType, ChannelAvailability } from '../models/channel.types'
import type { AlertChannelAvailabilitySource } from '../models/notification-bridge'

const CHANNEL_ORDER: readonly AlertChannelType[] = ['mail', 'whatsapp', 'slack', 'teams']

function alertChannel(channel: AlertChannelAvailabilitySource['channel']): AlertChannelType {
  return channel === 'email' ? 'mail' : channel
}

/** Project module 22's public read model into the Alerts vocabulary. */
export function alertChannelAvailability(
  source: readonly AlertChannelAvailabilitySource[],
): ChannelAvailability[] {
  const byChannel = new Map<AlertChannelType, ChannelAvailability>()
  for (const item of source) {
    const channel = alertChannel(item.channel)
    const values = [...item.recipients]
    byChannel.set(channel, {
      channel,
      configured: item.configured,
      turnedOn: item.enabled,
      values,
      selectable: item.configured && item.enabled,
    })
  }
  return CHANNEL_ORDER.flatMap((channel) => {
    const availability = byChannel.get(channel)
    return availability ? [availability] : []
  })
}

/** Merge workspace projections without making one workspace's config enable another's channel. */
export function mergeAlertChannelAvailability(
  workspaceChannels: readonly (readonly ChannelAvailability[])[],
): ChannelAvailability[] {
  return CHANNEL_ORDER.flatMap((channel) => {
    const matches = workspaceChannels.flatMap((items) =>
      items.filter((item) => item.channel === channel),
    )
    if (!matches.length) return []
    return [
      {
        channel,
        configured: matches.some((item) => item.configured),
        turnedOn: matches.some((item) => item.turnedOn),
        values: [...new Set(matches.flatMap((item) => item.values))],
        selectable: matches.some((item) => item.selectable),
      },
    ]
  })
}
